import { Box, Button, CircularProgress, Typography, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { observer } from 'mobx-react'

import DataLoadingSpinner from '../../../components/common/DataLoadingSpinner'
import CustomTable from '../../../components/common/custom-table/CustomTable'
import { useResumeBuilderStore } from '../../../store/resumebuilder.store'
import BlockMessage from '../../../components/common/BlockMessage'
import noFormImg from '../../../assets/no-resume-templates.svg'
import { useUserStore } from '../../../store/user.store'
import { Icons } from '../../../utils/utilities'
import CustomChip from '../../../components/common/CustomChip'

const tableColumns = [
    { label: "Form", field: "name", minWidth: "200px", padding: "10px 20px 10px 40px" },
    { label: "Added by", field: "added_by", renderCell: row => row.added_by.user_name, minWidth: "150px", padding: "10px 20px" },
    {
        label: "For institutes", field: "institutes", renderCell: row => ( <Box gap='10px' display="flex" flexWrap="wrap" alignItems="center">
            {row.access_list.length > 0 && row.access_list.map( item => (
                <CustomChip key={item} value={item} />
            ) )}
        </Box> ), minWidth: "100px", padding: "10px 40px 10px 20px"
    },
]

const ResumeForms = observer( () => {

    const [creatingForm, setCreatingForm] = useState( false )
    const [loading, setLoading] = useState( true )
    const [hasPermission, setHasPermission] = useState( true )

    const ResumeBuilderStore = useResumeBuilderStore()
    const UserStore = useUserStore()
    const navigate = useNavigate()

    const { palette, layout } = useTheme()

    const createAndNavigateToConfigureForm = async () => {
        setCreatingForm( true )
        const { success, data } = await ResumeBuilderStore.createForm( { formName: '', formDescription: '' } )
        setCreatingForm( false )
        if ( success ) {
            const role = UserStore.getUser.user_role.toUpperCase()
            if ( ["ADMIN", "SUBADMIN"].includes( role ) ) {
                navigate( `/admin/resume-forms/${data.id}` )
            } else if ( ["HOD", "PRESENTER", "FACULTY", "PRINCIPAL"].includes( role ) ) {
                navigate( `/faculty/resume-forms/${data.id}` )
            } else if ( ["STUDENT", "OBSERVER"].includes( role ) ) {
                navigate( `/student/resume-forms/${data.id}` )
            } else {
                navigate( `/resume-forms/${data.id}` )
            }
        }
    }

    const navigateToForm = ( id ) => {
        console.log( id )

        const role = UserStore.getUser.user_role.toUpperCase()
        if ( ["ADMIN", "SUBADMIN"].includes( role ) ) {
            navigate( `/admin/resume-forms/${id}` )
        } else if ( ["HOD", "PRESENTER", "FACULTY", "PRINCIPAL"].includes( role ) ) {
            navigate( `/faculty/resume-forms/${id}` )
        } else if ( ["STUDENT", "OBSERVER"].includes( role ) ) {
            navigate( `/student/resume-forms/${id}` )
        } else {
            navigate( `/resume-forms/${id}` )
        }
    }

    useEffect( () => {
        const getData = async () => {
            await ResumeBuilderStore.fetchForms()
            setLoading( false )
        }
        if ( UserStore.getUser.user_role === 'SUBADMIN' && !UserStore.getUser.user_permissions.resume_builder ) {
            setHasPermission( false )
        } else
            getData()
    }, [ResumeBuilderStore, UserStore] )

    return (
        hasPermission ? <Box flexGrow={1} display="flex" flexDirection="column" padding={layout.pagePadding} overflow="auto">
            <Box sx={{ minHeight: !loading && "350px", display: "flex", flexDirection: "column", gap: layout.sectionsGap, flexGrow: 1 }}>
                <Box display="flex" flexWrap="wrap" alignItems="center">
                    <Box flexGrow={1}>
                        <Typography variant="h1" fontWeight="600" component="h1" fontSize="16px">Resume Form</Typography>
                        <Typography variant="subtitle2" fontSize="12px" color='textSecondary'>Manage and build resume Form here</Typography>
                    </Box>
                    {!loading && <Button disableElevation variant='contained' sx={{ textTransform: "capitalize" }} startIcon={Icons.default.AddIcon}>Create</Button>}
                </Box>
                {/* {!loading && <Fab sx={{ position: "fixed", bottom: "20px", right: "20px" }} color='secondary' onClick={createAndNavigateToConfigureForm}>
                        {!creatingForm ? Icons.default.AddIcon : <CircularProgress sx={{ color: "white !important" }} size={20} />}
                    </Fab>} */}
                {!loading && ResumeBuilderStore.getForms.length === 0 && <Box borderRadius={layout.borderRadius} bgcolor={palette.contentBg} flexGrow={1} justifyContent="center" padding="20px" display="flex" flexDirection="column" gap="20px" alignItems="center">
                    <img src={noFormImg} height="150px" style={{ marginBottom: "20px" }} alt="No Form" />
                    <Typography color="textSecondary" variant='subtitle2'>Seems like there are no resume forms to show!</Typography>
                    {creatingForm ? <Button disabled variant='outlined'><Typography textTransform="capitalize" display="flex" gap="10px" alignItems="center"> <CircularProgress size={14} /> creating form... </Typography></Button> : <Button onClick={createAndNavigateToConfigureForm} variant="outlined" startIcon={Icons.default.AddIcon} sx={{ textTransform: "capitalize" }} > Add form </Button>}
                </Box>
                }
                {!loading && ResumeBuilderStore.getForms.length > 0 && <CustomTable dataIdKey="id" containerStyles={{ height: "fit-content", flexGrow: "initial" }} onRowClick={row => navigateToForm( row.id )} pageSize={50} columns={tableColumns} data={ResumeBuilderStore.getForms} />}

                {loading && <DataLoadingSpinner waitingMessage="Loading resume forms..." />}
            </Box>
        </Box> :
            <Box padding={layout.pagePadding} flexGrow={1}>
                <BlockMessage message={<span>You doesn't have permission to access this page! please contact <i>Alive co-ordinators</i> for further information.</span>} type="error" />
            </Box>
    )
} )

export default ResumeForms
